import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Pages.css";

const Projects = () => {

  const projectData = [
    {
      id: "1",
      name: "Groove Gear E-Commerce App",
      img: "/assets/project-groove-gear.png",
      description: "E-commerce platform for musical and percussion instruments built with the MERN stack.",
      website: "https://groove-gear-e-commerce-app-frontend.vercel.app/products",
      frontend: "https://github.com/don0716/groove-gear-e-commerce-app",
      backend: "https://github.com/don0716/groove-gear-ecommerce-backend"
    },{
      id: "2",
      name: "Anvaya CRM App",
      img: "/assets/proj-anvaya-crm.png",
      description: "Anvaya CRM is a web app to manage, track, and close leads with ease. Built with React, Express, and MongoDB, Anvaya also offers clear charts and reports on lead distribution, agent performance, and pipeline health.",
      website: "https://crm-app-anvaya.vercel.app/",
      frontend: "https://github.com/don0716/crm-app-anvaya",
      backend: "https://github.com/don0716/crm-app-backend"
    },{
      id: "2",
      name: "Worksana App",
      img: "/assets/proj-worksana.png",
      description: "Worksana is a web app designed to streamline task and project management, helping users organize, track, and complete work efficiently. Built with React, Express, and MongoDB, featuring user authentication to securely manage tasks and projects.",
      website: "https://worksana-frontend-app.vercel.app/",
      frontend: "https://github.com/don0716/worksana-frontend-app",
      backend: "https://github.com/don0716/worksana-backend"
    }
  ]
  
  return (
    <div
      className="projects-section py-5 d-flex align-items-center justify-content-center"
    >
      <Container className="text-center">
        <h2 className="fw-bold mb-5 text-light">My Projects 🚀</h2>
        <Row className="justify-content-center">
          {projectData.map((proj) => (
            <Col md={4} className="mb-4" key={proj.id}>
              <Card className="project-card h-100 text-dark">
                <Card.Img
                  style={{
                            height: "200px",       // fixed height for all cards
                            objectFit: "cover",    // crops and scales image to fit
                            width: "100%",          // make it full width
                          }}
                  variant="top"
                  src={proj.img}
                  alt={`Project ${proj.id}`}
                />
                <Card.Body >
                  <Card.Title className="fw-bold text-dark" >{proj.name}</Card.Title>
                  <Card.Text className="text-dark">
                    <small>{proj.description}</small>
                  </Card.Text>
                  <Link  to={proj.website} target="_blank">
                    <Button variant="warning" className="w-100 fw-bold my-2">
                      View Project
                    </Button>
                  </Link>
                  <Link to={proj.frontend} target="_blank">
                    <Button size="sm" variant="secondary" className="w-100 fw-bold my-2">
                      Frontend Code
                    </Button>
                  </Link>
                  <Link to={proj.backend} target="_blank">
                    <Button size="sm" variant="secondary" className="w-100 fw-bold my-2">
                      Backend Code
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Projects;
